
<table class="table table-striped">
  <thead>
    <tr>
      <th>Substituir</th>
      <th>Por</th>
      <th>nos Talhões/Tratamentos</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="produto in $ctrl.insumosSelecionados track by $index ">
      <td class="vertical-middle">{{produto.insumo_was.descricao}}/{{produto.insumo_was.unidade.abreviatura}}</td>
      <td class="vertical-middle">{{produto.insumo.descricao}} {{produto.insumo.unidade.abreviatura}}/ha</td>      
      <td class="vertical-middle">
        <div class="checkbox" ng-repeat="gleba in produto.glebas track by $index">
          <label>
            <input type="checkbox" ng-model="gleba.selecionado"> {{gleba.gleba.descricao}}
          </label>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<div class="pull-right">
  <button 
    ng-disabled="$ctrl.working" 
    class="btn btn-success" 
    name="salvar" 
    type="button" 
    ng-click="$ctrl.save()"> 
    <span ng-if="$ctrl.working"><i class="fa fa-spinner fa-spin"></i></span>
    Salvar
  </button> 
</div>
